package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class UniverseConfig(
    @SerialName("version")
    val version: Int = 0,

    @SerialName("displayName")
    val displayName: String = "",

    @SerialName("themeId")
    val themeId: String = DEFAULT_THEME_ID,

    @SerialName("features")
    val features: UniverseFeatures = UniverseFeatures(),

    @SerialName("modules")
    val modules: Set<GameModule> = emptySet(),

    @SerialName("dice")
    val dice: UniverseDiceConfig = UniverseDiceConfig(),

    @SerialName("currencySymbol")
    val currencySymbol: String = "$",

    @SerialName("characterMode")
    val characterMode: CharacterMode = CharacterMode.FREE_CONSTRUCTION,

    @SerialName("themeSeedColor")
    val themeSeedColor: Long? = null,
) {
    val isEmpty: Boolean get() = version == 0

    companion object {
        const val CURRENT_VERSION = 1
    }
}

@Serializable
data class UniverseFeatures(
    @SerialName("inventory")
    val inventory: Boolean = true,

    @SerialName("dice")
    val dice: Boolean = true,

    @SerialName("soundboard")
    val soundboard: Boolean = true,

    @SerialName("messages")
    val messages: Boolean = true,

    @SerialName("characterSheet")
    val characterSheet: Boolean = true
)

@Serializable
data class UniverseDiceConfig(
    @SerialName("available")
    val available: List<UniverseDie> = emptyList(),

    @SerialName("defaultDie")
    val defaultDie: DieType = DieType.D20,

    @SerialName("defaultCount")
    val defaultCount: Int = 1,

    @SerialName("multiEnabled")
    val multiEnabled: Boolean = false,

    @SerialName("modifiersEnabled")
    val modifiersEnabled: Boolean = false,

    @SerialName("totalEnabled")
    val totalEnabled: Boolean = true,

    @SerialName("highValuesWin")
    val highValuesWin: Boolean = true,

    @SerialName("faceStyle")
    val faceStyle: DiceFaceStyle = DiceFaceStyle.NUMERALS
)

/**
 * Style des faces des dés 3D. Valeur par défaut [NUMERALS] : les configs JSONB
 * existantes se désérialisent sans migration.
 */
@Serializable
enum class DiceFaceStyle {
    @SerialName("numerals")
    NUMERALS,

    /** La face « 1 » est remplacée par une tête de mort (hors d100). */
    @SerialName("skull_one")
    SKULL_ONE
}

@Serializable
data class UniverseDie(
    @SerialName("type")
    val type: DieType,

    @SerialName("criticalMin")
    val criticalMin: Int? = null,

    @SerialName("criticalMax")
    val criticalMax: Int? = null
) {
    fun toDieConfig(highValuesWin: Boolean = true): DieConfig =
        DieConfig(type, criticalMin, criticalMax, highValuesWin)

    companion object {
        fun fromDieConfig(config: DieConfig): UniverseDie =
            UniverseDie(config.type, config.criticalMin, config.criticalMax)
    }
}
